import debug from './debug';
import { hashString } from './hashString';
/**
 * Embed Link tag into document
 *
 * @return Promise
 */
export var loadLinkTag = function (url, doc) {
    if (doc === void 0) { doc = document; }
    return new Promise(function (resolve) {
        var id = hashString(url);
        var existingElement = doc.getElementById(id);
        if (existingElement) {
            resolve(url);
            return;
        }
        var element = doc.createElement('link');
        element.id = id;
        element.href = url;
        element.rel = 'stylesheet';
        element.onload = function () { return resolve(url); };
        element.onerror = function () {
            debug('Cannot load CSS URL', url);
            resolve(url);
        };
        doc.head.appendChild(element);
    });
};
